import { render, staticRenderFns } from "./indexTab0.vue?vue&type=template&id=41c872e9&scoped=true"
import script from "./indexTab0.vue?vue&type=script&lang=js"
export * from "./indexTab0.vue?vue&type=script&lang=js"
import style0 from "./indexTab0.vue?vue&type=style&index=0&id=41c872e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c872e9",
  null
  
)

export default component.exports